import {
  Card,
  CardBody,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  Row,
  UncontrolledDropdown,
} from "reactstrap";
import VeticalBarsChart from "../charts/VeticalBarsChart";
import { RxCaretDown } from "react-icons/rx";
import { useTranslation } from "../../languages";

const DashboardCustomerCard = ({ todayTotalOrders, chartData, total }) => {
  const { t } = useTranslation();
  return (
    <Card
      className="border-none standard-card full-height"
      style={{ borderRadius: "20px" }}
    >
      <CardBody>
        <div className="d-flex px-3 py-2 mb-3  justify-content-between ">
          <div>
            <h4 className="f-6 color-primary-blue mb-1">{total} %</h4>
            <h6 className="f-4 color-half-black-2 m-0 ">
              {t("totalVisitors")}{" "}
            </h6>
          </div>
          <UncontrolledDropdown>
            <DropdownToggle
              style={{
                background: "rgba(238, 238, 238, 1)",
                minWidth: "88px",
                borderRadius: "7px",
              }}
              className="d-flex gap-2 align-items-center text-black border-none justify-content-between"
            >
              <small className="f-4 m-0">{t("thisYear")} </small>
              <div>
                <RxCaretDown size={20} />
              </div>
            </DropdownToggle>
            <DropdownMenu>
              <DropdownItem>{t("thisYear")} </DropdownItem>
              <DropdownItem>{t("thisMonth")} </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </div>
        <VeticalBarsChart
          dataName={"chart"}
          height={250}
          width={"100%"}
          xAxisData={[
            `Jan`,
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
          ]}
          yAxisData={[23, 100, 33, 100, 33, 23, 44, 111, 100, 33, 23, 44]}
        />
      </CardBody>
    </Card>
  );
};

export default DashboardCustomerCard;
